import styles from '../components/app/app.scss';

export default function appRect() {
  return typeof window !== 'undefined'
    ? window.document.getElementsByClassName(styles.app)[0].getBoundingClientRect()
    : null;
}
